export default __webpack_public_path__ + "static/media/leaverequest.13453ea6.png";